import { get } from "lodash";
import { useSite } from "./use-site";
export var useContactEmail = function useContactEmail() {
  var site = useSite();
  return process.env.CONTACT_EMAIL || get(site, 'contactEmail', '');
};